'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n'], ['\n  box-sizing: border-box;\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: inherit;\n  }\n\n  button {\n    cursor: pointer;\n  }\n  button[disabled] {\n    cursor: default;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  border-bottom: 1px solid;\n\n  /* This is purposely using the data cell color token. */\n  /* The header border color is used for dividers between cells. */\n  border-bottom-color: ', ';\n\n  font-family: ', ';\n  font-weight: ', ';\n  text-align: ', ';\n\n  /* Hides content, but will still be read by screen readers */\n  ', ';\n\n  /* This should hide the cell, retain dimensions, and still be read\n     by screen readers. */\n  opacity: ', ';\n\n  @media print {\n    border-bottom-color: ', ';\n    opacity: 1;\n  }\n'], ['\n  border-bottom: 1px solid;\n\n  /* This is purposely using the data cell color token. */\n  /* The header border color is used for dividers between cells. */\n  border-bottom-color: ', ';\n\n  font-family: ', ';\n  font-weight: ', ';\n  text-align: ', ';\n\n  /* Hides content, but will still be read by screen readers */\n  ', ';\n\n  /* This should hide the cell, retain dimensions, and still be read\n     by screen readers. */\n  opacity: ', ';\n\n  @media print {\n    border-bottom-color: ', ';\n    opacity: 1;\n  }\n']),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _SortIcon = require('./SortIcon'),
    _SortIcon2 = _interopRequireDefault(_SortIcon),
    _styles = require('../styles'),
    _themes = require('../themes'),
    _propTypes3 = require('../propTypes');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Styled = {
  button: {},
  div: {},
  span: {}
},
    normalizeStyles = (0, _styles.css)(_templateObject),
    cellStyles = (0, _styles.css)(_templateObject2, (0, _themes.getStyle)('TableDataCell_borderColor'), (0, _themes.getStyle)('TableHeaderCell_fontFamily'), (0, _themes.getStyle)('TableHeaderCell_fontWeight'), function (props) {
  return props.sc.numeric ? 'right' : 'left';
}, function (props) {
  return props.sc.visuallyHidden ? (0, _styles.visuallyHidden)() : '';
}, function (props) {
  return props.sc.visuallyHiddenRetainDimensions ? 0 : 1;
}, function (props) {
  return props.theme.vstui.color.black;
});
Styled.th = _styledComponents2.default.th.withConfig({
  displayName: 'TableHeaderCell__th'
})(['', ';', ';padding:0;background-color:', ';border-left:1px solid;border-left-color:', ';color:', ';font-size:', ';line-height:1.23;&:first-child{border-left:none;}@media print{background:', ';border-left:none;color:', ';font-weight:', ';}'], normalizeStyles, cellStyles, (0, _themes.getStyle)('TableHeaderCell_backgroundColor'), (0, _themes.getStyle)('TableHeaderCell_borderColor'), (0, _themes.getStyle)('TableHeaderCell_color'), function (props) {
  return props.theme.vstui.rem((0, _themes.getStyle)('TableHeaderCell_fontSize')(props));
}, function (props) {
  return props.theme.vstui.color.white;
}, function (props) {
  return props.theme.vstui.color.black;
}, function (props) {
  return props.theme.vstui.typography.fontWeightMedium;
}), Styled.div.headerText = _styledComponents2.default.div.withConfig({
  displayName: 'TableHeaderCell__headerText'
})(['position:relative;width:100%;background:none;border:none;border-radius:0;@media print{padding:0 5px;}']), Styled.button.sort = _styledComponents2.default.button.withConfig({
  displayName: 'TableHeaderCell__sort'
})(['width:100%;padding:5px 20px;background:none;border:none;outline-offset:-4px;color:inherit;font-family:inherit;font-size:inherit;line-height:inherit;text-align:', ';', ';'], function (props) {
  return props.sc.numeric ? 'right' : 'left';
}, function (props) {
  return props.sc.visuallyHidden ? (0, _styles.visuallyHidden)() : '';
}), Styled.div.sortIconWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'TableHeaderCell__sortIconWrapper'
})(['position:absolute;top:calc(50% - 2px);right:8px;@media print{display:none;}']), Styled.span.sortDirection = _styledComponents2.default.span.withConfig({
  displayName: 'TableHeaderCell__sortDirection'
})(['', ';'], function (props) {
  return props.sc.visuallyHidden ? (0, _styles.visuallyHidden)() : '';
});

var TableHeaderCell = function (_Component) {
  function TableHeaderCell(props) {
    _classCallCheck(this, TableHeaderCell);

    var _this = _possibleConstructorReturn(this, (TableHeaderCell.__proto__ || Object.getPrototypeOf(TableHeaderCell)).call(this, props));

    return _this.handleClick = _this.handleClick.bind(_this), _this;
  }

  return _inherits(TableHeaderCell, _Component), _createClass(TableHeaderCell, [{
    key: 'handleClick',
    value: function handleClick(event) {
      this.props.onClick(event, this.props.index);
    }
  }, {
    key: 'renderSortIcon',
    value: function renderSortIcon() {
      var _props = this.props,
          index = _props.index,
          sortIndex = _props.sortIndex,
          sortOrder = _props.sortOrder,
          tableType = _props.tableType;
      if (void 0 === sortIndex && void 0 === index) return null;

      if (sortIndex === index) {
        var direction = 1 === sortOrder ? 'ascending' : 'descending';
        return _react2.default.createElement(Styled.div.sortIconWrapper, null, 'header' === tableType && _react2.default.createElement(_SortIcon2.default, {
          direction: direction
        }), _react2.default.createElement(Styled.span.sortDirection, {
          sc: {
            visuallyHidden: !0
          }
        }, 'sorted ', direction));
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          hidden = _props2.hidden,
          numeric = _props2.numeric,
          tableType = _props2.tableType,
          theme = _props2.theme,
          conditionalButtonProps = {};
      return ('header' === tableType && hidden || 'body' === tableType) && (conditionalButtonProps.tabIndex = -1), _react2.default.createElement(Styled.th, {
        sc: {
          numeric: numeric,
          visuallyHiddenRetainDimensions: 'body' === tableType
        },
        scope: 'col',
        theme: theme
      }, _react2.default.createElement(Styled.div.headerText, {
        sc: {
          numeric: numeric
        }
      }, _react2.default.createElement(Styled.button.sort, _extends({}, conditionalButtonProps, {
        onClick: this.handleClick,
        sc: {
          visuallyHidden: hidden
        }
      }), children, this.renderSortIcon())));
    }
  }]), TableHeaderCell;
}(_react.Component);

TableHeaderCell.propTypes = {
  children: _propTypes2.default.node,
  hidden: _propTypes2.default.bool,
  index: _propTypes2.default.number,
  numeric: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  sortIndex: _propTypes2.default.number,
  sortOrder: _propTypes2.default.number,
  tableType: _propTypes2.default.oneOf(['body', 'header']),
  theme: _propTypes3.themeShape
}, TableHeaderCell.defaultProps = {
  theme: (0, _themes.createTheme)()
}, TableHeaderCell.displayName = 'TableHeaderCell';
var TableHeaderCellWithTheme = (0, _themes.withTheme)(TableHeaderCell);
TableHeaderCellWithTheme.WrappedComponent = TableHeaderCell, exports.default = TableHeaderCellWithTheme;